import i18n from '../../../i18n';

export const initialState = {
    i18n,
    meetingsList: [],
    defaultMeetingsList: [],
    customMeetingsList: [],
    upcommingMeetingList: null,
    meetingDetails: null,
    convocationContent: null,
    default_meetting_filter: {
        filter_type: "upcoming",
    },
    meetingTypeSelection: null,
    meetingListByType: [],
    meetingFilterData: [],
    meetingTimerClick: 0,
    meetingTimerPopup: {},
    meetingVoterSummary: [],
    meetingVotingData: null,
    meetingCommentList: [],
    meetingMomLogs: [],
    transcriptionDetail: null,
    momSignatureData: null,
    deletedUserList: [],
    resolutionTypesList: [
        { translationKey: "agenda.lblInPerson", value: "In Person" },
        { translationKey: "agenda.lblRemote", value: "Remote" },
        { translationKey: "agenda.lblHybrid", value: "Hybrid" },
        { translationKey: "agenda.lblInWriting", value: "In Writing" },
        { translationKey: "agenda.lblOthers", value: "Others" },
    ],
};

const state = { ...initialState };

export default state;